import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AuthModule } from 'app/core/auth/auth.module';
import { IconsModule } from 'app/core/icons/icons.module';
import { TranslocoCoreModule } from 'app/core/transloco/transloco.module';
import { ApiErrorToastInterceptor } from './Interceptors/api-error-toast.interceptor';
import { CInterceptor } from './Interceptors/cInterceptor';
import { ErrorInterceptor } from './Interceptors/error.interceptor';

@NgModule({
    imports: [
        AuthModule,
        IconsModule,
        TranslocoCoreModule,
        CommonModule,
        HttpClientModule
    ],
    exports: [CommonModule, HttpClientModule],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ApiErrorToastInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CInterceptor,
            multi: true,
        },
        // BreadcrumbService,
        // GeneralService,
        // FileService,
        // SignalrService,
    ],
})
export class CoreModule {
    /**
     * Constructor
     */
    constructor(
        @Optional() @SkipSelf() parentModule?: CoreModule
    ) {
        // Do not allow multiple injections
        if (parentModule) {
            throw new Error('CoreModule has already been loaded. Import this module in the AppModule only.');
        }
    }
}
